import {EntityViewProperties} from "./EntityViewProperties";

export const AllEntitiesviewAdmins = `
    query requestGeometries {
        allEntitiesviewAdmins {
        nodes {
            stAsgeojson
            ${EntityViewProperties}
        }
    }
}`
